import React from "react";

const SuralinkBrand: React.FC = () => (
  <svg viewBox="0 0 60 12" fill="#225282">
    <path
      d="M6.6,9.4c0,0.7-0.4,1.3-1.1,1.8c-0.6,0.4-1.3,0.6-2.2,0.6c-0.4,0-0.8,0-1.2-0.1c-0.4-0.1-0.8-0.2-1.1-0.3
 l0.2-0.9c0.3,0.1,0.7,0.3,1.1,0.4c0.4,0.1,0.7,0.1,0.9,0.1c0.6,0,1-0.1,1.4-0.3c0.5-0.2,0.7-0.6,0.7-1c0-0.3-0.1-0.5-0.3-0.7
 C5,8.6,4.8,8.5,4.5,8.3c-0.1,0-0.4-0.1-0.9-0.3l-1-0.3C2.1,7.6,1.7,7.3,1.4,7C1.1,6.7,1,6.3,1,5.9c0-0.7,0.3-1.2,0.9-1.6
 c0.6-0.4,1.3-0.5,2.2-0.5c0.3,0,0.7,0,1,0.1c0.3,0.1,0.7,0.1,1,0.2L5.9,4.9C5.7,4.9,5.4,4.8,5,4.7C4.7,4.7,4.3,4.6,4.1,4.6
 c-0.6,0-1,0.1-1.4,0.3C2.3,5.1,2.1,5.4,2.1,5.8c0,0.3,0.1,0.6,0.4,0.7c0.2,0.1,0.4,0.2,0.9,0.3l1.2,0.3C5.2,7.4,5.7,7.6,6,7.9
 C6.4,8.3,6.6,8.8,6.6,9.4z"
    />
    <path
      d="M14.8,11.5h-1.1v-1.3c-0.4,0.4-0.8,0.8-1.2,1c-0.5,0.3-1,0.5-1.5,0.5c-0.7,0-1.2-0.2-1.6-0.5
 c-0.4-0.4-0.6-1.1-0.6-2.1V3.9H10v4.5c0,0.9,0.1,1.6,0.3,1.9c0.2,0.3,0.5,0.5,1,0.5c0.4,0,0.9-0.2,1.4-0.5c0.3-0.2,0.6-0.5,0.9-0.8
 V3.9h1.1V11.5z"
    />
    <path
      d="M20.9,4.8c-0.4,0-0.9,0.2-1.3,0.6c-0.2,0.2-0.5,0.5-0.7,0.9v5.3h-1.1V3.9h1.1v1.3c0.3-0.4,0.6-0.8,0.9-1.1
 c0.4-0.3,0.9-0.5,1.3-0.5c0.3,0,0.6,0,0.8,0.1c0.2,0,0.4,0.1,0.9,0.2l-0.5,1.1c-0.2-0.1-0.5-0.2-0.8-0.3
 C21.4,4.8,21.1,4.8,20.9,4.8z"
    />
    <path
      d="M29.7,11.5h-1.1v-1c-0.8,0.8-1.6,1.2-2.5,1.2c-0.6,0-1.1-0.1-1.5-0.4c-0.5-0.4-0.8-0.9-0.8-1.6
 c0-0.6,0.2-1.1,0.7-1.5c0.4-0.3,0.9-0.6,1.5-0.8c0.5-0.1,0.9-0.2,1.3-0.2L28.6,7V6.7c0-0.7-0.2-1.2-0.6-1.5
 c-0.3-0.3-0.8-0.4-1.3-0.4c-0.3,0-0.7,0.1-1.1,0.2c-0.4,0.1-0.8,0.3-1,0.4l-0.3-0.7C24.5,4.4,25,4.2,25.5,4
 c0.6-0.2,1.1-0.3,1.5-0.3c0.8,0,1.5,0.2,1.9,0.6c0.5,0.5,0.8,1.2,0.8,2.2V11.5z M28.6,7.8l-1.2,0.1c-0.9,0.1-1.6,0.3-2,0.6
 c-0.3,0.3-0.5,0.6-0.5,1.1c0,0.4,0.2,0.7,0.5,0.9c0.3,0.2,0.6,0.3,0.9,0.3c0.5,0,0.9-0.1,1.4-0.4c0.3-0.2,0.6-0.5,0.9-0.8V7.8z"
    />
    <path d="M36.3,11.5h-3.1V1.3h-1.9v-1h3v10.2h2V11.5z" />
    <path
      d="M41.1,11.5H40V4.9h-2v-1h3.1V11.5z M41.3,1.7c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2
 c-0.2,0-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5C40.2,1.1,40.4,1,40.6,1c0.2,0,0.4,0.1,0.5,0.2
 C41.2,1.4,41.3,1.5,41.3,1.7z"
    />
    <path
      d="M50.6,11.5h-1.1V7.1c0-0.9-0.1-1.6-0.3-1.9c-0.2-0.3-0.5-0.5-1-0.5c-0.4,0-0.9,0.2-1.4,0.5
 c-0.3,0.2-0.6,0.5-0.9,0.8v5.4h-1.1V3.9h1.1v1.3c0.4-0.4,0.8-0.8,1.2-1c0.5-0.3,1-0.4,1.5-0.4c0.7,0,1.2,0.2,1.6,0.5
 c0.4,0.4,0.6,1.1,0.6,2.1V11.5z"
    />
    <path d="M54.5,11.5h-1.1V0.3h1.1V11.5z M59,11.5h-1.3l-3.1-4.1l3.2-3.6H59l-3.1,3.5L59,11.5z" />
  </svg>
);

export default SuralinkBrand;
